/**
 * Created by joerg on 13.06.17.
 */
import React, {Component} from 'react';
import BaseDataEntry from './BaseDataEntry'
import GebaudeSrukturEntry from './GebaudeSrukturEntry'
import DetailDataEntry from './DetailDataEntry'
import Kostenanalyse from './Kostenanalyse'
import KostenanalyseBrespa from './KostenanalyseBrespa'
import KostenanalyseHF from './KostenanalyseHF'
import KostenanalyseOrtbeton from './KostenanalyseOrtbeton'
import Kurzergebnis from './Kurzergebnis'
import BaseDicken from './BaseDicken'
import {inject,observer} from 'mobx-react';

@inject('baseDataStore')
@inject('brespaAnalyseStore')
@inject('ortbetonAnalyseStore')
@inject('halbfertigAnalyseStore')
    @observer
class MainEntries extends Component {
    render() {
        return (
            <div>
                <div className="row" >
                    <div className="col-md-12 col-lg-12 col-sm-12">
                        <BaseDataEntry baseDataStore={this.props.baseDataStore} brespaDataStore={this.props.brespaAnalyseStore} />
                    </div>


                </div>

                {/*<div className="row" >
                    <div className="col-md-12 col-lg-12 col-sm-12">
                        <BaseDicken brespaDataStore={this.props.brespaAnalyseStore} baseDataStore={this.props.baseDataStore} />
                    </div>
                </div>*/}


            </div>

        )
    }
}

export default MainEntries


// WEBPACK FOOTER //
// ./src/components/MainEntries.js